import { createTheme } from "@mui/material";
import { CARD_SHADOW } from "./tokens";

export const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#009DE0",
      dark: "#0087C3",
      light: "#33B1E6",
      contrastText: "#fff",
    },
    secondary: { main: "#002A5C", dark: "#001F45", light: "#1A3D6E" },
    error: { main: "#E30613" },
    success: { main: "#2E7D32" },
    warning: { main: "#FFB800" },
    background: { default: "#F5F7FA", paper: "#FFFFFF" },
    text: { primary: "#002A5C", secondary: "#5C6B7A" },
    divider: "#DEE3EA",
  },
  typography: {
    fontFamily: '"DM Sans", "Helvetica Neue", Arial, sans-serif',
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none" as const, fontWeight: 600 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        outlined: {
          borderColor: "#E4E9F0",
          borderRadius: 12,
          boxShadow: CARD_SHADOW,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: { fontFamily: '"DM Sans", "Helvetica Neue", Arial, sans-serif' },
      },
    },
  },
});
